export default (initialState = {}) => {
  return () => {
    return {
      file: null,
      file_name: "",
      file_type: "",
      ...initialState,
    };
  };
};
